import { Attribution } from 'types'

interface Params {
  endDate: string
  startDate: string
  attr: Attribution
}

export const getCountries = ({ endDate, startDate, attr }: Params) => {
  switch (attr) {
    case 'first':
      return `SELECT SUM(first.total_amount), SUM(first.recurring_payments_amount), SUM(first.orders_amount), SUM(stats.views), SUM(first.leads), SUM(first.total_orders), SUM(first.new_customers), stats.country FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.country`
    case 'last':
      return `SELECT SUM(last.total_amount), SUM(last.recurring_payments_amount), SUM(last.orders_amount), SUM(stats.views), SUM(last.leads), SUM(last.total_orders), SUM(last.new_customers), stats.country FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.country`
    case 'linear':
      return `SELECT SUM(linear_page.total_amount), SUM(linear_page.recurring_payments_amount), SUM(linear_page.orders_amount), SUM(stats.views), SUM(linear_page.leads), SUM(linear_page.total_orders), SUM(stats.new_customers), stats.country FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.country`
    case 'ai':
      return `SELECT SUM(ai_page.total_amount), SUM(ai_page.recurring_payments_amount), SUM(ai_page.orders_amount), SUM(stats.views), SUM(ai_page.leads), SUM(ai_page.total_orders), SUM(stats.new_customers), stats.country FROM page WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' GROUP BY stats.country`
    default:
      return ''
  }
}
